import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import DateFnsUtils from '@date-io/date-fns'
import enUS from 'date-fns/locale/en-US'
import arSA from 'date-fns/locale/ar-SA'
import PageTitle from '../PageTitle'
import { TextField, InputAdornment, InputLabel, MenuItem, Select, Button } from '@material-ui/core'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import { DatePicker } from '@material-ui/pickers'
import EventIcon from '@material-ui/icons/Event'
import { LanguageConsumer } from '../../context/LanguageContext'
import { ListingConsumer } from '../../context/ListingContext'
import { FormLoader } from '../Loader/FormLoader'
import { AuthConsumer } from '../../context/AuthContext'
import GeneralTableWithFilter from '../GeneralTableWithFilter'
import { useStyles } from './Styles'
import receiverTypes from '../../configurations/notification-receiver-types'
import notificationTypes from '../../configurations/notification-types'
import notificationChannels from '../../configurations/notification-channels'
import 'moment/locale/ar-sa'
import Moment from 'react-moment'
import NotificationDetails from './NotificationDetails'

const NotificationsPageContent = ({ locale }) => {
  const [selectedNotification, setSelectedNotification] = React.useState({})
  const [notificationModalOpen, setNotificationModalOpen] = React.useState(false)
  const classes = useStyles()
  const intl = useIntl()
  const submitFilterRef = React.useRef(null)

  const handleEnterKeyDown = (event) => {
    if (event.key === 'Enter' && !!submitFilterRef?.current) {
      submitFilterRef.current.click()
    }
  }

  // React.useEffect(() => {
  //   console.log(selectedNotification)
  // }, [selectedNotification])

  const handleNotificationIdClick = (singleNotification) => {
    setSelectedNotification(singleNotification);
    setNotificationModalOpen(true)
  }

  const getColumns = (listingData) => ([
    {
      name: 'notificationId',
      key_name: 'NotificationId',
      isCustomTextFieldFilter: true,
      label: intl.formatMessage({ id: 'Fields.label.view.notificationId' }),
      options: {
        filter: true,
        filterType: 'custom',
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let itemCode = listingData[dataIndex]?.notificationId
          let singleNotificationItem = listingData[dataIndex]
          return !!itemCode &&
            <Button size={'large'} variant={'text'} color={'primary'} disableRipple
              onClick={() => handleNotificationIdClick(singleNotificationItem)}
              className={classes.modifyLink}>{itemCode}</Button>
        },
        customFilterListOptions: {
          render: (v) => (
            <div className={classes.FilterChip}>
              <FormattedMessage id='Fields.label.view.notificationId' />:
              <span>{v}</span>
            </div>
          )
        },
        filterOptions: {
          display: (filterList, onChange, index, column) => (
            <TextField
              fullWidth
              label={intl.formatMessage({ id: 'Fields.label.view.notificationId' })}
              id='NotificationId'
              name='NotificationId'
              value={filterList[index][0] || ''}
              onKeyDown={handleEnterKeyDown}
              onChange={(event) => {
                if (!!event.target.value) {
                  filterList[index][0] = event.target.value
                } else {
                  filterList[index] = []
                }
                onChange(filterList[index], index, column)
              }}
            />
          )
        }
      }
    },
    {
      name: 'receiverName',
      key_name: 'receiverName',
      label: intl.formatMessage({ id: 'Fields.label.view.notificationReceiverName' }),
      options: {
        filter: false,
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <AuthConsumer>
              {({ taxpayerData, userData }) => {
                let value = listingData[dataIndex]?.receiverId === 1 ? userData.username : taxpayerData.name;
                return <span>{value}</span>;
              }}
            </AuthConsumer>
          )
        }
      }
    },
    {
      name: 'receiverType',
      key_name: 'ReceiverType',
      label: intl.formatMessage({ id: 'Fields.label.view.notificationReceiverType' }),
      options: {
        filter: true,
        filterType: 'custom',
        print: false,
        sort: false,
        download: false,
        customFilterListOptions: {
          render: (v) => {
            let valueArr = v?.length && receiverTypes?.length ? receiverTypes.filter((item) => item.id.toString() === v[0].toString()) : []
            return !!valueArr && !!valueArr.length && <div className={classes.FilterChip}>
              <FormattedMessage id='Fields.label.view.notificationReceiverType' />:
              <span>{valueArr[0][`name_${locale}`]}</span>
            </div>
          }
        },
        filterOptions: {
          display: (filterList, onChange, index, column) => (
            <>
              <InputLabel id="ReceiverType-label" className={'MuiInputLabel-shrink'}><FormattedMessage
                id='Fields.label.view.notificationReceiverType' /></InputLabel>
              <Select
                fullWidth
                displayEmpty
                labelId="ReceiverType-label"
                id="ReceiverType"
                name="ReceiverType"
                MenuProps={{ disableScrollLock: true }}
                value={filterList[index][0] || '1'}
                label={intl.formatMessage({ id: 'Fields.label.view.notificationReceiverType' })}
                onChange={(event) => {
                  if (!!event.target.value) {
                    filterList[index][0] = event.target.value
                  } else {
                    filterList[index] = []
                  }
                  onChange(filterList[index], index, column)
                }}
              >
                {/* <MenuItem value={''}><FormattedMessage id='Table.List.Table.All'/></MenuItem> */}
                {receiverTypes?.length && receiverTypes.map((item) => (
                  !!item.id &&
                  <MenuItem key={item.id} value={item.id}>{item[`name_${locale}`]}</MenuItem>))}
              </Select>
            </>
          )
        }
      }
    },
    {
      name: 'typeName',
      key_name: 'Type',
      label: intl.formatMessage({ id: 'Fields.label.view.notificationType' }),
      options: {
        filter: true,
        filterType: 'custom',
        print: false,
        sort: false,
        download: false,
        customFilterListOptions: {
          render: (v) => {
            let valueArr = v?.length && notificationTypes?.length ? notificationTypes.filter((item) => item.id.toString() === v[0].toString()) : []
            return !!valueArr && !!valueArr.length && <div className={classes.FilterChip}>
              <FormattedMessage id='Fields.label.view.notificationType' />:
              <span>{valueArr[0][`name_${locale}`]}</span>
            </div>
          }
        },
        filterOptions: {
          display: (filterList, onChange, index, column) => (
            <>

              <InputLabel id="notificationType-label" className={'MuiInputLabel-shrink'}><FormattedMessage
                id='Fields.label.view.notificationType' /></InputLabel>
              <Select
                fullWidth
                displayEmpty
                labelId="notificationType-label"
                id="Type"
                name="Type"
                MenuProps={{ disableScrollLock: true }}
                value={filterList[index][0] || ''}
                label={intl.formatMessage({ id: 'Fields.label.view.notificationType' })}
                onChange={(event) => {
                  if (!!event.target.value) {
                    filterList[index][0] = event.target.value
                  } else {
                    filterList[index] = []
                  }
                  onChange(filterList[index], index, column)
                }}
              >
                <MenuItem value={''}><FormattedMessage id='Table.List.Table.All' /></MenuItem>
                {notificationTypes.filter((i) => i.receiver_type === (filterList[2].length ? filterList[2][0].toString() : '1'))?.length && notificationTypes.filter((i) => i.receiver_type === (filterList[2].length ? filterList[2][0].toString() : '1')).map((item) => (
                  !!item.id &&
                  <MenuItem key={item.id} value={item.id}>{item[`name_${locale}`]}</MenuItem>))}
              </Select>
            </>
          )
        }
      }
    },
    {
      name: 'channel',
      key_name: 'Channel',
      label: intl.formatMessage({ id: 'Fields.label.view.notificationChannel' }),
      options: {
        filter: true,
        filterType: 'custom',
        print: false,
        sort: false,
        download: false,
        customFilterListOptions: {
          render: (v) => {
            let valueArr = v?.length && notificationChannels?.length ? notificationChannels.filter((item) => item.id.toString() === v[0].toString()) : []
            return !!valueArr && !!valueArr.length && <div className={classes.FilterChip}>
              <FormattedMessage id='Fields.label.view.notificationChannel' />:
              <span>{valueArr[0][`name_${locale}`]}</span>
            </div>
          }
        },
        filterOptions: {
          display: (filterList, onChange, index, column) => (
            <>
              <InputLabel id="notificationChannel-label" className={'MuiInputLabel-shrink'}><FormattedMessage
                id='Fields.label.view.notificationChannel' /></InputLabel>
              <Select
                fullWidth
                displayEmpty
                labelId="notificationChannel-label"
                id="Channel"
                name="Channel"
                MenuProps={{ disableScrollLock: true }}
                value={filterList[index][0] || ''}
                label={intl.formatMessage({ id: 'Fields.label.view.notificationChannel' })}
                onChange={(event) => {
                  if (!!event.target.value) {
                    filterList[index][0] = event.target.value
                  } else {
                    filterList[index] = []
                  }
                  onChange(filterList[index], index, column)
                }}
              >
                <MenuItem value={''}><FormattedMessage id='Table.List.Table.All' /></MenuItem>
                {notificationChannels?.length && notificationChannels.map((item) => (
                  !!item.id &&
                  <MenuItem key={item.id} value={item.id}>{item[`name_${locale}`]}</MenuItem>))}
              </Select>
            </>
          )
        }
      }
    },
    {
      name: 'address',
      key_name: 'address',
      label: intl.formatMessage({ id: 'Fields.label.view.notificationAddress' }),
      options: {
        filter: false,
        display: 'false',
        print: false,
        sort: false,
        download: false
      }
    },
    // {
    //   name: 'notificationDeliveryId',
    //   key_name: 'notificationDeliveryId',
    //   label: intl.formatMessage({ id: 'Fields.label.view.notificationDeliveryId' }),
    //   options: {
    //     filter: false,
    //     display: 'false',
    //     print: false,
    //     sort: false,
    //     download: false
    //   }
    // },
    // {
    //   name: 'notificationSubject',
    //   key_name: 'notificationSubject',
    //   label: intl.formatMessage({ id: 'Fields.label.view.notificationSubject' }),
    //   options: {
    //     filter: false,
    //     display: 'false',
    //     print: false,
    //     sort: false,
    //     download: false
    //   }
    // },
    // {
    //   name: 'messageData',
    //   key_name: 'messageData',
    //   label: intl.formatMessage({ id: 'Fields.label.view.notificationMessageData' }),
    //   options: {
    //     filter: false,
    //     display: 'false',
    //     print: false,
    //     sort: false,
    //     download: false
    //   }
    // },
    // {
    //   name: 'finalMessage',
    //   key_name: 'finalMessage',
    //   label: intl.formatMessage({ id: 'Fields.label.view.notificationFinalMessage' }),
    //   options: {
    //     filter: false,
    //     display: 'false',
    //     print: false,
    //     sort: false,
    //     download: false
    //   }
    // },
    // {
    //   name: 'documentUUID',
    //   key_name: 'documentUUID',
    //   label: intl.formatMessage({ id: 'Fields.label.view.notificationDocumentUUID' }),
    //   options: {
    //     filter: false,
    //     display: 'false',
    //     print: false,
    //     sort: false,
    //     download: false
    //   }
    // },
    // {
    //   name: 'detailsUrl',
    //   key_name: 'detailsUrl',
    //   label: intl.formatMessage({ id: 'Fields.label.view.notificationDetailsUrl' }),
    //   options: {
    //     filter: false,
    //     display: 'false',
    //     print: false,
    //     sort: false,
    //     download: false,
    //     customBodyRenderLite: (dataIndex) => {
    //       let value = listingData[dataIndex].detailsUrl
    //       return !!value && <a href={value} target={'_blank'} rel="noreferrer"
    //         className={classes.mailWrapper}>{value}</a>
    //     }
    //   }
    // },
    {
      name: 'language',
      key_name: 'language',
      label: intl.formatMessage({ id: 'Fields.label.view.notificationLanguage' }),
      options: {
        filter: false,
        display: 'false',
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let value = listingData[dataIndex]?.language
          return !!value && <FormattedMessage id={`Notification.language.${value.toLowerCase()}`} />
        }
      }
    },
    {
      name: 'receivedDateTime',
      key_name: 'DateFrom',
      label: intl.formatMessage({ id: 'Fields.label.view.notificationReceivedDateTime' }),
      options: {
        filter: true,
        filterType: 'custom',
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let value = listingData[dataIndex]?.receivedDateTime
          return !!value && <div className={classes.cellDataWrapper}>
            <strong><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
              format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{value}</Moment></strong>
            {/* <span><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
              format="hh:mm A">{value}</Moment></span> */}
          </div>
        },
        customFilterListOptions: {
          render: (v) => (
            <div className={classes.FilterChip}>
              <FormattedMessage id='Fields.Labels.notification.DateFrom' />:
              <span><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{v[0]}</Moment></span>
            </div>
          )
        },
        filterOptions: {
          display: (filterList, onChange, index, column) => (
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale === 'ar' ? arSA : enUS}>
              <DatePicker
                autoOk
                fullWidth
                showTodayButton
                format="dd-MM-yyyy"
                margin="dense"
                id="DateFrom"
                name="DateFrom"
                clearable
                label={intl.formatMessage({ id: 'Fields.Labels.notification.DateFrom' })}
                placeholder={intl.formatMessage({ id: 'Fields.Labels.notification.DateFrom' })}
                InputProps={{
                  onKeyDown: handleEnterKeyDown,
                  endAdornment:
                    <InputAdornment position="end">
                      <EventIcon />
                    </InputAdornment>
                }}
                value={filterList[index][0] || null}
                animateYearScrolling
                onChange={(date) => {
                  if (!!date) {
                    filterList[index][0] = date
                  } else {
                    filterList[index] = []
                  }
                  onChange(filterList[index], index, column)
                }}
              />
            </MuiPickersUtilsProvider>
          )
        }
      }
    },
    {
      name: 'deliveredDateTime',
      key_name: 'DateTo',
      label: intl.formatMessage({ id: 'Fields.label.view.notificationDeliveredDateTime' }),
      options: {
        filter: true,
        filterType: 'custom',
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let value = listingData[dataIndex]?.deliveredDateTime
          return !!value && <div className={classes.cellDataWrapper}>
            <strong><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
              format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{value}</Moment></strong>
            {/* <span><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
              format="hh:mm A">{value}</Moment></span> */}
          </div>
        },
        customFilterListOptions: {
          render: (v) => (
            <div className={classes.FilterChip}>
              <FormattedMessage id='Fields.Labels.notification.DateTo' />:
              <span><Moment className={'noWrap'} locale={locale === 'ar' ? 'ar-sa' : 'en-us'}
                format={locale === 'ar' ? 'YYYY/MM/DD' : 'DD/MM/YYYY'}>{v[0]}</Moment></span>
            </div>
          )
        },
        filterOptions: {
          display: (filterList, onChange, index, column) => (
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale === 'ar' ? arSA : enUS}>
              <DatePicker
                autoOk
                fullWidth
                showTodayButton
                format="dd-MM-yyyy"
                margin="dense"
                id="DateTo"
                name="DateTo"
                clearable
                label={intl.formatMessage({ id: 'Fields.Labels.notification.DateTo' })}
                placeholder={intl.formatMessage({ id: 'Fields.Labels.notification.DateTo' })}
                InputProps={{
                  onKeyDown: handleEnterKeyDown,
                  endAdornment:
                    <InputAdornment position="end">
                      <EventIcon />
                    </InputAdornment>
                }}
                value={filterList[index][0] || null}
                animateYearScrolling
                onChange={(date) => {

                  if (!!date) {
                    filterList[index][0] = date
                  } else {
                    filterList[index] = []
                  }
                  onChange(filterList[index], index, column)
                }}
              />
            </MuiPickersUtilsProvider>
          )
        }
      }
    },
    {
      name: 'status',
      key_name: 'status',
      label: intl.formatMessage({ id: 'Fields.label.view.notificationStatus' }),
      options: {
        filter: false,
        print: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex) => {
          let value = listingData[dataIndex]?.status
          return !!value && <FormattedMessage id={`Notification.status.${value}`} defaultMessage={value} />
        }
      }
    }
  ])


  return (
    <>
      <PageTitle title={<FormattedMessage id='NotificationsPageContent.PageTitle' />} />
      <NotificationDetails
        isDialogOpen={notificationModalOpen}
        DialogTitle={<FormattedMessage id="NotificationsPageContent.ModalNotificationTitle" />}
        cancelDialog={() => setNotificationModalOpen(false)}
        selectedNotification={selectedNotification}
        locale={locale}
      />
      <AuthConsumer>
        {({ taxpayerData, userPermissions }) => (
          <LanguageConsumer>
            {({ locale }) => (
              <ListingConsumer>
                {({
                  listingCount, listingRowsPerPage, listingPage, handleChangeListingPage, handleChangeListingRowsPerPage,
                  handleListingFilterSubmit, listingData, listingLoading
                }) => (
                  <div className={'listing-wrapper'}>
                    <GeneralTableWithFilter
                      columns={getColumns(listingData)}
                      type={'Notifications'}
                      submitFilterRef={submitFilterRef}
                      listingData={listingData}
                      listingCount={listingCount}
                      listingRowsPerPage={listingRowsPerPage}
                      listingPage={listingPage}
                      handleChangeListingPage={handleChangeListingPage}
                      handleChangeListingRowsPerPage={handleChangeListingRowsPerPage}
                      handleListingFilterSubmit={handleListingFilterSubmit}
                      taxpayerData={taxpayerData}
                      userPermissions={userPermissions}
                      locale={locale}
                      titleKey={'NotificationsPageContent.PageTitle'}
                    />
                    {!!listingLoading && <FormLoader loading={true} />}
                  </div>
                )}
              </ListingConsumer>
            )}
          </LanguageConsumer>
        )}
      </AuthConsumer>
    </>
  )
}

export default NotificationsPageContent
